// Datos de los 6 kits de la tienda v5 — single source of truth compartida entre
// Kits.jsx (grid) y KitDetalle.jsx. HARDCODEADO por ahora; en producción viene de DB.
//
// ⚠ NÚMEROS A CONFIRMAR CON NICO/FINANZAS (Roberto) ANTES DE PRODUCCIÓN:
//   - precio / tachado / ahorro: uso los del grid de Kits (internamente consistentes:
//     tachado = precio + ahorro). Confirmado por Nico (Familiar $1.490/$1.900/$410).
//   - precioUnica (compra única / mes 1): salvo Familiar (real $1.680), el resto son
//     PLACEHOLDERS calculados (≈ precio×1.13) → ver flags TODO abajo.
//
// La descripción NO lleva el número de productos hardcodeado: se compone en el componente
// con `productos.length` (descCorta/descLarga son el texto DESPUÉS de "N productos ").

export const KITS = [
  {
    codigo: 'solo', nombre: 'Kit Solo', tier: 'Essential', grupo: 'essential',
    personas: '1–2 personas',
    descCorta: 'esenciales que arman tu mes.',
    descLarga: 'de limpieza chequeados uno por uno. Lo esencial para vivir solo o en pareja, todo el mes, entregado el día que pasamos por tu barrio.',
    precio: 990, ahorro: 310, tachado: 1300,
    // TODO Fase 4: reemplazar con precio real de Roberto/finanzas antes de producción
    precioUnica: 1120, // PLACEHOLDER calculado (≈ precio×1.13)
    productos: [
      { cant: '1×', nombre: 'Jabón lavarropas', det: '1L', emoji: '🧺' },
      { cant: '1×', nombre: 'Detergente', det: '750ml', emoji: '🍽️' },
      { cant: '1×', nombre: 'Desengrasante', det: '500ml', emoji: '🍳' },
      { cant: '1×', nombre: 'Limpiavidrios', det: '500ml', emoji: '🪞' },
      { cant: '1×', nombre: 'Papel higiénico', det: 'x12', emoji: '🧻' },
      { cant: '1×', nombre: 'Toallas cocina', det: 'x6', emoji: '🧻' },
      { cant: '1×', nombre: 'Paños', det: 'x5', emoji: '🧽' },
      { cant: '1×', nombre: 'Jabón espuma', det: '300ml', emoji: '🧼' },
      { cant: '1×', nombre: 'Lustramuebles', det: '200ml', emoji: '🪵' },
      { cant: '1×', nombre: 'Multiuso baño', det: '500ml', emoji: '🚿' },
    ],
  },
  {
    codigo: 'familiar', nombre: 'Kit Familiar', tier: 'Essential', grupo: 'essential', destacado: true,
    personas: '3–4 personas',
    descCorta: 'para cocina, baño y ropa.',
    descLarga: 'de limpieza chequeados uno por uno. Lo que tu casa necesita todo el mes, entregado el día que pasamos por tu barrio. Sin listas, sin súper, sin acordarte.',
    precio: 1490, ahorro: 410, tachado: 1900,
    precioUnica: 1680, // real (viene de la maqueta original)
    productos: [
      { cant: '2×', nombre: 'Jabón lavarropas', det: '1L', emoji: '🧺' },
      { cant: '1×', nombre: 'Suavizante', det: '1L', emoji: '🌸' },
      { cant: '2×', nombre: 'Detergente', det: '750ml', emoji: '🍽️' },
      { cant: '1×', nombre: 'Desengrasante', det: '500ml', emoji: '🍳' },
      { cant: '1×', nombre: 'Limpiavidrios', det: '500ml', emoji: '🪞' },
      { cant: '2×', nombre: 'Papel higiénico', det: 'x12', emoji: '🧻' },
      { cant: '1×', nombre: 'Toallas cocina', det: 'x6', emoji: '🧻' },
      { cant: '2×', nombre: 'Paños', det: 'x5', emoji: '🧽' },
      { cant: '1×', nombre: 'Jabón tocador', det: '100g', emoji: '🧼' },
      { cant: '1×', nombre: 'Multiuso baño', det: '500ml', emoji: '🚿' },
    ],
  },
  {
    codigo: 'hogar-plus', nombre: 'Kit Hogar+', tier: 'Essential', grupo: 'essential',
    personas: '5 o más personas',
    descCorta: 'que rinden todo el mes en casa grande.',
    descLarga: 'de limpieza chequeados uno por uno. Rinden todo el mes en casa grande o familia numerosa, entregados el día que pasamos por tu barrio.',
    precio: 2490, ahorro: 610, tachado: 3100,
    // TODO Fase 4: reemplazar con precio real de Roberto/finanzas antes de producción
    precioUnica: 2810, // PLACEHOLDER calculado (≈ precio×1.13)
    productos: [
      { cant: '3×', nombre: 'Jabón lavarropas', det: '1L', emoji: '🧺' },
      { cant: '2×', nombre: 'Suavizante', det: '1L', emoji: '🌸' },
      { cant: '2×', nombre: 'Detergente', det: '750ml', emoji: '🍽️' },
      { cant: '2×', nombre: 'Desengrasante', det: '500ml', emoji: '🍳' },
      { cant: '1×', nombre: 'Limpiavidrios', det: '500ml', emoji: '🪞' },
      { cant: '3×', nombre: 'Papel higiénico', det: 'x12', emoji: '🧻' },
      { cant: '2×', nombre: 'Toallas cocina', det: 'x6', emoji: '🧻' },
      { cant: '2×', nombre: 'Paños', det: 'x5', emoji: '🧽' },
      { cant: '1×', nombre: 'Home spray', det: '350ml', emoji: '🌺' },
    ],
  },
  {
    codigo: 'duo', nombre: 'Kit Dúo', tier: 'Premium', grupo: 'premium', premium: true,
    personas: '1–2 personas',
    descCorta: 'premium con aromas exclusivos.',
    descLarga: 'premium con aromas exclusivos brasileños, chequeados uno por uno. Para vivir solo o en pareja con un plus de calidad, entregados el día de tu barrio.',
    precio: 1090, ahorro: 310, tachado: 1400,
    // TODO Fase 4: reemplazar con precio real de Roberto/finanzas antes de producción
    precioUnica: 1230, // PLACEHOLDER calculado (≈ precio×1.13)
    productos: [
      { cant: '1×', nombre: 'Jabón concentrado', det: 'Chá Branco 1L', emoji: '🧺' },
      { cant: '1×', nombre: 'Detergente', det: 'premium 750ml', emoji: '🍽️' },
      { cant: '1×', nombre: 'Desengrasante', det: 'cítrico 500ml', emoji: '🍳' },
      { cant: '1×', nombre: 'Papel higiénico', det: 'hoja doble x12', emoji: '🧻' },
      { cant: '1×', nombre: 'Toallas cocina', det: 'x6', emoji: '🧻' },
      { cant: '1×', nombre: 'Jabón tocador', det: 'Castanha do Brasil', emoji: '🧼' },
      { cant: '1×', nombre: 'Home spray', det: '350ml', emoji: '🌺' },
      { cant: '1×', nombre: 'Aromatizante textil', det: '400ml', emoji: '🌸' },
      { cant: '1×', nombre: 'Paños', det: 'premium x5', emoji: '🧽' },
      { cant: '1×', nombre: 'Lustramuebles', det: 'Lavanda 200ml', emoji: '🪵' },
    ],
  },
  {
    codigo: 'confort', nombre: 'Kit Confort', tier: 'Premium', grupo: 'premium', premium: true,
    personas: '3–4 personas',
    descCorta: 'premium con fragancias importadas.',
    descLarga: 'premium con fragancias importadas, chequeados uno por uno. Para tu familia con un plus de calidad, entregados el día que pasamos por tu barrio.',
    precio: 1680, ahorro: 470, tachado: 2150,
    // TODO Fase 4: reemplazar con precio real de Roberto/finanzas antes de producción
    precioUnica: 1900, // PLACEHOLDER calculado (≈ precio×1.13)
    productos: [
      { cant: '2×', nombre: 'Jabón concentrado', det: 'Chá Branco 1L', emoji: '🧺' },
      { cant: '1×', nombre: 'Suavizante', det: 'premium 1L', emoji: '🌸' },
      { cant: '2×', nombre: 'Detergente', det: 'premium 750ml', emoji: '🍽️' },
      { cant: '1×', nombre: 'Desengrasante', det: 'cítrico 500ml', emoji: '🍳' },
      { cant: '1×', nombre: 'Limpiavidrios', det: 'con vinagre 500ml', emoji: '🪞' },
      { cant: '2×', nombre: 'Papel higiénico', det: 'hoja doble x12', emoji: '🧻' },
      { cant: '1×', nombre: 'Toallas cocina', det: 'x6', emoji: '🧻' },
      { cant: '2×', nombre: 'Home spray', det: '350ml (surtido)', emoji: '🌺' },
      { cant: '2×', nombre: 'Paños', det: 'premium x5', emoji: '🧽' },
    ],
  },
  {
    codigo: 'exclusive', nombre: 'Kit Exclusive', tier: 'Premium', grupo: 'premium', premium: true,
    personas: '5 o más personas',
    descCorta: 'premium, todos importados, para casa grande.',
    descLarga: 'premium, todos importados y chequeados uno por uno. La máxima calidad para casa grande, entregada el día que pasamos por tu barrio.',
    precio: 2690, ahorro: 710, tachado: 3400,
    // TODO Fase 4: reemplazar con precio real de Roberto/finanzas antes de producción
    precioUnica: 3040, // PLACEHOLDER calculado (≈ precio×1.13)
    productos: [
      { cant: '3×', nombre: 'Jabón concentrado', det: 'Chá Branco 1L', emoji: '🧺' },
      { cant: '2×', nombre: 'Suavizante', det: 'premium 1L', emoji: '🌸' },
      { cant: '3×', nombre: 'Detergente', det: 'premium 750ml', emoji: '🍽️' },
      { cant: '2×', nombre: 'Desengrasante', det: 'cítrico 500ml', emoji: '🍳' },
      { cant: '1×', nombre: 'Limpiavidrios', det: 'con vinagre 500ml', emoji: '🪞' },
      { cant: '3×', nombre: 'Papel higiénico', det: 'hoja doble x12', emoji: '🧻' },
      { cant: '2×', nombre: 'Toallas cocina', det: 'x6', emoji: '🧻' },
      { cant: '3×', nombre: 'Home spray', det: '350ml (surtido)', emoji: '🌺' },
      { cant: '1×', nombre: 'Difusor aromas', det: 'premium', emoji: '🌸' },
    ],
  },
];

export function getKit(codigo) {
  return KITS.find((k) => k.codigo === codigo) || null;
}

// % de ahorro vs súper (con el mínimo comunicado de 12% — regla comercial del proyecto).
export function ahorroPct(k) {
  return Math.max(12, Math.round((k.ahorro / k.tachado) * 100));
}

// Precio bonificado de los meses 2 y 3 (se devuelve la diferencia): (3·mensual − única)/2.
export function precioBonif(k) {
  return Math.round((3 * k.precio - k.precioUnica) / 2);
}
